"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query organizationFees($orgId: String!) {
    organizationFees(orgId: $orgId) {
      _id
      name
      orgId
      eventId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      createdBy
      createdAt
      updatedBy
      updatedAt
      disabled
      paymentMethods
      isApplyPlatformFee
    }
  }
`;
exports.default = query;
//# sourceMappingURL=organizationFees.query.js.map